export const steps = {
    welcome: 'welcome',
    photo: 'photo',
    responsibilities: 'responsibilities',
    about: 'about',
    mobile: 'mobile',
    'update-responsibilities': 'update-responsibilities',
}
